import { render } from "./ScenarioAnswerOrNotSetting.vue?vue&type=template&id=ca118ea6&scoped=true"
import script from "./ScenarioAnswerOrNotSetting.vue?vue&type=script&lang=ts"
export * from "./ScenarioAnswerOrNotSetting.vue?vue&type=script&lang=ts"

import "./ScenarioAnswerOrNotSetting.vue?vue&type=style&index=0&id=ca118ea6&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-ca118ea6"

export default script
import QList from 'quasar/src/components/item/QList.js';
import QToolbar from 'quasar/src/components/toolbar/QToolbar.js';
import QToolbarTitle from 'quasar/src/components/toolbar/QToolbarTitle.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';import Ripple from 'quasar/src/directives/Ripple.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QList,QToolbar,QToolbarTitle,QItem,QItemSection,QItemLabel,QBtn,QIcon});qInstall(script, 'directives', {Ripple});
